<template>
	<div id="app">
		<Header v-if="headerShow"></Header>
		<router-view></router-view>
		<Footer v-if="headerShow"></Footer>
	</div>
</template>
<script>
	// 粤海头尾
	import Header from "./components/common/HeaderYH.vue"
	import Footer from "./components/common/FooterYH.vue"

	// 融创头尾
	// import Header from "./components/common/HeaderRC.vue"
	// import Footer from "./components/common/FooterRC.vue"

	import Vue from 'vue'
	import axios from "axios"

	export default {
		name: 'app',
		data() {
			return {
				headerShow: true
			}
		},
		created() {
			//		    this.getAccessToken();
		},
		mounted() {
			// if(!sessionStorage.a){
			//     this.clearCookie()
			//     this.clearCookie1()
			// 	sessionStorage.a = "a"
			// }
		},
		methods: {
			clearCookie() {
				var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
				if (keys) {
					for (var i = keys.length; i--;)
						document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + "; path=/";
				}
			},
			clearCookie1() {
				var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
				if (keys) {
					for (var i = keys.length; i--;)
						document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			},
			getAccessToken() {
				axios.post("/gu/api/v1/hub/auth/getAccessToken").then((res) => {
					localStorage.accessToken = res.data.data.accessToken;
					Vue.prototype.$token = {
						headers: {
							'accessToken': res.data.data.accessToken,
							'userToken': localStorage.userToken,
						}
					};
				}).catch((error) => {
					console.log(error);
				})
			}
		},
		components: {
			Header,
			Footer
		},
		watch: {
			$route(to, from) {
				if (this.$route.path === "/questions" || this.$route.path === "/time-out" || this.$route.path === "/answer-success" ||
					this.$route.path === "/invalid") { // 例，问卷路径
					this.headerShow = false;
				} else {
					this.headerShow = true;
				}
			}
		}
	}
</script>

<!--<script type="text/javascript">-->
<!--var _hmt = _hmt || [];-->
<!--(function() {-->
<!--var hm = document.createElement("script");-->
<!--hm.src = "https://hm.baidu.com/hm.js?ebbe9069a11c96701e8a5b7802849511";-->
<!--var s = document.getElementsByTagName("script")[0];-->
<!--s.parentNode.insertBefore(hm, s);-->
<!--})();-->
<!--</script>-->

<style>

</style>



// WEBPACK FOOTER //
// App.vue?376b0750